import { MetaFunction, useNavigate } from "@remix-run/react";
import { ActionFunction, LoaderFunction, redirect } from "@remix-run/node";
import LoginForm from "app/components/Login";
import { loginAction } from "app/actions/login.action";
import { getAuthFromRequest } from "app/auth/auth";
import { Modal, ModalContent, ModalHeader, ModalBody } from "@heroui/react";

export const meta: MetaFunction = () => {
  return [
    { title: "Login | Promotional Products Now " },
    { name: "description", content: "Welcome to Promotional Products Now" },
  ];
};

export const loader: LoaderFunction = async ({ request }) => {
  const user = await getAuthFromRequest(request);
  if (user) return redirect("/");
  return null;
};

export const action: ActionFunction = async ({ request }) => {
  return loginAction(request);
};

export default function Login(): JSX.Element {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <Modal
      isKeyboardDismissDisabled={true}
      isDismissable={true}
      placement="top-center"
      backdrop="blur"
      isOpen={true}
      onOpenChange={(open: boolean) => {
        open ? () => {} : handleClose();
      }}
      className="mt-20 mx-2"
    >
      <ModalContent className="border border-gray-200 dark:border-gray-500 dark:bg-gray-800">
        <ModalHeader className="flex flex-col">
          <h1 className="text-2xl md:text-3xl text-dark font-bold text-center">
            Login to your account
          </h1>
          <p className="mt-4 text-lg font-semibold text-dark text-center">
            Enter your account details below
          </p>
        </ModalHeader>
        <ModalBody className="">
          <LoginForm />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
